export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white py-16">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="/logo-diwan.png" 
                alt="ديوان - جمعية ديوان الشبابية"
                className="h-16 w-auto object-contain brightness-0 invert"
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.style.display = 'none';
                  const parent = target.parentElement;
                  if (parent) {
                    parent.innerHTML = '<div class="w-12 h-12 bg-gradient-to-br from-[#2F4F9F] to-[#FF6B6B] rounded-full flex items-center justify-center"><i class="ri-lightbulb-flash-line text-white text-2xl"></i></div><span class="font-bold text-2xl">ديوان</span>';
                  }
                }}
              />
            </div>
            <p className="text-gray-400 leading-relaxed">
              ديوان ... شريك الشباب 🤝
            </p>
            <p className="text-gray-500 text-sm mt-2">
              تمكين الجيل القادم من المبتكرين من خلال الشراكات الاستراتيجية والدعم المؤسسي
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4">روابط سريعة</h3>
            <ul className="space-y-3">
              <li>
                <a href="#overview" className="text-gray-400 hover:text-[#FF8E53] transition-colors cursor-pointer">
                  نظرة عامة
                </a>
              </li>
              <li>
                <a href="#spaces" className="text-gray-400 hover:text-[#FF8E53] transition-colors cursor-pointer">
                  المساحات
                </a>
              </li>
              <li>
                <a href="#impact" className="text-gray-400 hover:text-[#FF8E53] transition-colors cursor-pointer">
                  التأثير
                </a>
              </li>
              <li>
                <a href="#partnership" className="text-gray-400 hover:text-[#FF8E53] transition-colors cursor-pointer">
                  الشراكة
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold text-lg mb-4">تواصل معنا</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-gray-400">
                <i className="ri-mail-line text-[#FF8E53]"></i>
                <a href="mailto:info@dfy.org.sa" className="hover:text-white transition-colors">
                  info@dfy.org.sa
                </a>
              </li>
              <li className="flex items-center gap-3 text-gray-400">
                <i className="ri-phone-line text-[#FF8E53]"></i>
                <a href="tel:+966592544688" className="hover:text-white transition-colors" dir="ltr">
                  +966 59 254 4688
                </a>
              </li>
              <li className="flex items-center gap-3 text-gray-400">
                <i className="ri-map-pin-line text-[#FF8E53]"></i>
                <span>المدينة المنورة، المملكة العربية السعودية</span>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="font-bold text-lg mb-4">تابعنا</h3>
            <div className="flex gap-4 justify-start">
              <a
                href="https://instagram.com/d4ymed"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center hover:bg-gradient-to-br hover:from-purple-600 hover:to-pink-600 transition-all duration-300 cursor-pointer"
                title="Instagram"
              >
                <i className="ri-instagram-fill text-xl"></i>
              </a>
              <a
                href="https://x.com/d4ymed"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center hover:bg-black transition-all duration-300 cursor-pointer"
                title="X (Twitter)"
              >
                <i className="ri-twitter-x-fill text-xl"></i>
              </a>
              <a
                href="https://wa.me/966592544688"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center hover:bg-green-500 transition-all duration-300 cursor-pointer"
                title="WhatsApp"
              >
                <i className="ri-whatsapp-fill text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex justify-center items-center">
          <p className="text-gray-400 text-center leading-relaxed">
            © 2026 جميع الحقوق محفوظة لجمعية ديوان الشبابية بالمدينة المنورة - ترخيص رقم 5531
          </p>
        </div>
      </div>
    </footer>
  );
}
